import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { apiMiddleware } from 'redux-api-middleware';
import rootReducer from './rootReducer';
import authMiddleware from './authMiddleware'

const logger = createLogger({
  collapsed: true,
  predicate: () =>
    process.env.NODE_ENV === 'development'
});

const middlewares = [
  authMiddleware,
  thunkMiddleware,
  apiMiddleware,
  process.env.NODE_ENV !== 'production' && logger
].filter(Boolean);

const createStoreWithMiddleware = applyMiddleware(
  ...middlewares,
)(createStore);

export default (initialState) => {
  const store = createStoreWithMiddleware(rootReducer, initialState);
  return store;
}
